var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-alert-footer",class:{
    'modal-show': _vm.modalAlertFooterShow,
    'modal-hide': !_vm.modalAlertFooterShow
  }},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.modalAlertFooterText))])])}
var staticRenderFns = []

export { render, staticRenderFns }